"use strict";

var _themeSections = require("@shopify/theme-sections");

var _flickityImagesloaded = _interopRequireDefault(require("flickity-imagesloaded"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Section: Shop By Theme
 * ------------------------------------------------------------------------------
 *
 * @namespace shopByTheme
 */

/**
 * DOM selectors.
 */


var selectors = {
  container: '[js-shop-by-theme="container"]',
  carousel: '[js-shop-by-theme="carousel"]',
  cell: '[js-shop-by-theme="slide"]'
};
/**
 * Instance globals.
 */

var carouselSlider = {};
/**
 * Register the `shop-by-theme` section type.
 */

(0, _themeSections.register)('shop-by-theme', {
  /**
   * Cache selectors.
   * - Define necessary variables and make available for component use.
   */
  cacheSelectors: function cacheSelectors() {
    var container = "[data-section-id=\"".concat(this.id, "\"]");
    var carousel = "".concat(container, " ").concat(selectors.carousel);
    var cells = "".concat(container, " ").concat(selectors.cell);
    this.cache = {
      container: container,
      carousel: carousel,
      cells: cells
    };
  },

  /**
   * Check if the section exist.
   */
  isSliderEnabled: function isSliderEnabled() {
    return document.querySelector(this.cache.container) !== null;
  },

  /**
   * Construct carousel using imported Carousel.
   */
  constructCarousel: function constructCarousel() {
    carouselSlider = new _flickityImagesloaded["default"](this.cache.carousel, {
      imagesLoaded: true,
      cellAlign: 'left',
      contain: true,
      freeScroll: true,
      pageDots: false,
      prevNextButtons: true,
      wrapAround: true
    });
  },

  /**
   * Construct new carousel on `section:load`.
   */
  onLoad: function onLoad() {
    this.cacheSelectors();

    if (this.isSliderEnabled()) {
      this.constructCarousel();
    }
  }
});